class ProductNav extends HTMLElement {
  connectedCallback() {
    const tabRoot = this.querySelector('.product-nav__sidebar') || this;
    const panelRoot = this.querySelector('.product-nav__panels') || this;

    this.tabs = [...tabRoot.querySelectorAll('[data-product-nav-tab]')];
    this.panels = [...panelRoot.querySelectorAll('[data-product-nav-submenu-panel]')];
    this.isDrawer = this.closest('.product-nav-drawer') != null;

    this.tabs.forEach((tab, index) => {
      tab.dataset.index = String(index);
    });

    this.panels.forEach((panel, index) => {
      panel.dataset.index = String(index);
    });

    this.onTabActivate = (event) => {
      const tab = event.target.closest('[data-product-nav-tab]');
      if (!tab || !this.contains(tab)) return;

      const shouldNavigate = !this.isDrawer && tab.matches('a[href]');
      if (shouldNavigate) {
        this.setActive(Number(tab.dataset.index));
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      this.setActive(Number(tab.dataset.index));
    };

    this.onTabHover = (event) => {
      const tab = event.currentTarget;
      this.setActive(Number(tab.dataset.index));
    };

    if (this.isDrawer) {
      this.addEventListener('click', this.onTabActivate, true);
      this.addEventListener('keydown', this.onTabKeydown.bind(this), true);
    } else {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabActivate);
        tab.addEventListener('mouseenter', this.onTabHover);
      });
    }

    if (this.tabs.length) {
      const initialTab = Number(this.dataset.initialTab);
      this.setActive(Number.isNaN(initialTab) ? 0 : initialTab);
    }
  }

  disconnectedCallback() {
    if (this.isDrawer) {
      this.removeEventListener('click', this.onTabActivate, true);
    } else {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.onTabActivate);
        tab.removeEventListener('mouseenter', this.onTabHover);
      });
    }
  }

  onTabKeydown(event) {
    const tab = event.target.closest('[data-product-nav-tab]');
    if (!tab || !this.contains(tab)) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    event.stopPropagation();
    this.setActive(Number(tab.dataset.index));
  }

  setActive(index) {
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels?.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

customElements.define('product-nav', ProductNav);

function highlightProductNavForCurrentPage() {
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

  document.querySelectorAll('[data-product-nav-menu-item]').forEach((menuItem) => {
    const matchingLink = [...menuItem.querySelectorAll('.product-nav__product')].find((link) => {
      try {
        const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
        return linkPath === currentPath;
      } catch {
        return false;
      }
    });

    if (!matchingLink) return;

    if (menuItem.dataset.navContext === 'drawer') {
      menuItem.querySelector('summary')?.classList.add('menu-drawer__menu-item--active');
    } else {
      const summary = menuItem.querySelector('summary');
      const label = summary?.querySelector('span:not(.svg-wrapper)');
      label?.classList.add('header__active-menu-item');
    }
  });
}

function positionProductNavMenuItems() {
  document.querySelectorAll('[data-nav-context="drawer"][data-product-nav-menu-item]').forEach((item) => {
    const drawerMenu = document.querySelector('.menu-drawer__menu.has-submenu');
    if (drawerMenu && item.parentElement !== drawerMenu) {
      drawerMenu.appendChild(item);
    }
  });

  document.querySelectorAll('[data-product-nav-menu-item]').forEach((item) => {
    const context = item.dataset.navContext;
    const position = Number(item.dataset.menuPosition);
    const navList =
      context === 'drawer'
        ? item.closest('.menu-drawer__menu.has-submenu')
        : item.closest('.list-menu.list-menu--inline');

    if (!navList || Number.isNaN(position)) return;

    const menuItems = [...navList.children].filter(
      (child) => !child.hasAttribute('data-product-nav-menu-item')
    );

    if (position >= menuItems.length) {
      navList.appendChild(item);
      return;
    }

    navList.insertBefore(item, menuItems[position] || null);
  });
}

function bindProductNavDrawerEvents() {
  const headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer || typeof headerDrawer.onSummaryClick !== 'function') return;

  document
    .querySelectorAll('[data-product-nav-menu-item][data-nav-context="drawer"] summary')
    .forEach((summary) => {
      if (summary.dataset.drawerNavBound === 'true') return;
      summary.dataset.drawerNavBound = 'true';
      summary.addEventListener('click', headerDrawer.onSummaryClick.bind(headerDrawer));
    });

  document
    .querySelectorAll('[data-product-nav-menu-item][data-nav-context="drawer"] .menu-drawer__close-button')
    .forEach((button) => {
      if (button.dataset.drawerNavBound === 'true') return;
      button.dataset.drawerNavBound = 'true';
      button.addEventListener('click', headerDrawer.onCloseButtonClick.bind(headerDrawer));
    });
}

function initProductNavMenu() {
  positionProductNavMenuItems();
  bindProductNavDrawerEvents();
  highlightProductNavForCurrentPage();
}

if (customElements.get('header-drawer')) {
  initProductNavMenu();
} else {
  customElements.whenDefined('header-drawer').then(initProductNavMenu);
}
